import { PERMISSIONS } from '@src/constants';

export const customSelectPermissions = ({ width = '100%' }) => ({
  container: (provided) => ({
    ...provided,
    width,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#d3d3d3' : '#ffffff',
    color: state.isSelected ? '#000' : '#333',
    ':hover': {
      backgroundColor: '#f0f0f0',
    },
    fontWeight: state.isSelected ? 'bold' : 'normal',
  }),
  menu: (provided) => ({
    ...provided,
    padding: '5px 0',
  }),
  singleValue: (provided) => ({
    ...provided,
    padding: '2px 5px',
    borderRadius: '3px',
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor:
      data.value === PERMISSIONS.ALL ? '#ababab' : styles.backgroundColor,
    color: 'black',
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.value === PERMISSIONS.ALL ? 'white' : styles.color,
  }),
});
